// storeApi removed - use API calls directly
import type { DashboardState, Metrics } from "./types";

export function calculateDashboardData(): DashboardState {
    const metrics: Metrics = {
        ready_to_call: 0,
        callbacks_waiting: 0,
        transfers_waiting: 0,
        confirmation_rate: 0,
        scheduled_today: 0,
        scheduled_future: 0,
        scheduled_total: 0,
        active_blocks: 0,
    };

    return {
        metrics,
        nextOrders: [],
        transferQueue: [],
        callbacks: [],
        navOutbox: [],
        blocks: [],
    };
}
